module.exports = __webpack_public_path__ + "img/bankicon1.1b056979.png";